/**
 * Truck Loading rounds — 3 hardcoded rounds, exactly 5 crates each.
 * Each crate's `key` references a pre-rendered PNG (box-{round}-{slot}.png)
 * with the multiplication expression baked into the sprite, so the game
 * code never draws text on crates.
 *
 * Round layouts come from the AMJ-2026 Figma design.
 */

const R1 = {
  target: 12,
  crates: [
    { a: 3,  b: 4, value: 12, isCorrect: true,  key: 'box-1-1' }, // 3 × 4
    { a: 12, b: 1, value: 12, isCorrect: true,  key: 'box-1-2' }, // 12 × 1
    { a: 2,  b: 6, value: 12, isCorrect: true,  key: 'box-1-3' }, // 2 × 6
    { a: 5,  b: 3, value: 15, isCorrect: false, key: 'box-1-4' }, // 5 × 3
    { a: 4,  b: 4, value: 16, isCorrect: false, key: 'box-1-5' }, // 4 × 4
  ],
};

const R2 = {
  target: 24,
  crates: [
    { a: 5,  b: 5, value: 25, isCorrect: false, key: 'box-2-1' }, // 5 × 5
    { a: 12, b: 2, value: 24, isCorrect: true,  key: 'box-2-2' }, // 12 × 2
    { a: 4,  b: 6, value: 24, isCorrect: true,  key: 'box-2-3' }, // 4 × 6
    { a: 5,  b: 4, value: 20, isCorrect: false, key: 'box-2-4' }, // 5 × 4
    { a: 8,  b: 3, value: 24, isCorrect: true,  key: 'box-2-5' }, // 8 × 3
  ],
};

const R3 = {
  target: 20,
  crates: [
    { a: 5,  b: 5, value: 25, isCorrect: false, key: 'box-3-1' }, // 5 × 5
    { a: 11, b: 2, value: 22, isCorrect: false, key: 'box-3-2' }, // 11 × 2
    { a: 10, b: 2, value: 20, isCorrect: true,  key: 'box-3-3' }, // 10 × 2
    { a: 5,  b: 4, value: 20, isCorrect: true,  key: 'box-3-4' }, // 5 × 4
    { a: 6,  b: 3, value: 18, isCorrect: false, key: 'box-3-5' }, // 6 × 3
  ],
};

export const ROUNDS = [R1, R2, R3];

export const ROUND_BOX_KEYS = ROUNDS.flatMap(r => r.crates.map(c => c.key));

function shuffle(arr) {
  const out = arr.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}

/**
 * Get the round for `roundIndex` (0, 1, 2). Crate order is shuffled so the
 * correct boxes don't always land in the same conveyor slots between plays.
 */
export function getRound(roundIndex) {
  const def = ROUNDS[roundIndex] || R1;
  const shuffled = shuffle(def.crates).map(c => ({ ...c }));
  const correctCount = shuffled.filter(c => c.isCorrect).length;
  return {
    target: def.target,
    crates: shuffled,
    correctCount,
  };
}

// Legacy alias.
export function generateRound() {
  return getRound(0);
}
